module.exports = {
    siteTitle: 'Smart Internet', // <title>
    manifestName: 'Internet',
    manifestShortName: 'Smart Internet', // max 12 characters
    manifestStartUrl: '/',
    manifestBackgroundColor: '#E3DBEC',
    manifestThemeColor: '#B8DCE7',
    manifestDisplay: 'standalone',
    manifestIcon: 'src/assets/img/website-icon.png',
    pathPrefix: `/gatsby-starter-stylish/`, // This path is subpath of your hosting https://domain/portfolio
    heading: 'Smart Internet',
    subHeading: 'Connect.Browse.GooNet',

    // social
    socialLinks: [{
            icon: '',
            name: 'Github',
            url: 'https://robotdejoe.netlify.app/',
        },
        {
            icon: '',
            name: 'Twitter',
            url: '#',
        },
        {
            icon: '',
            name: 'Facebook',
            url: '#',
        },
    ],
    email: 'paajoeincorporations@yahoo.com',
    phone: '000-00000',
    address: '305 Del Sol, Sunnyvale, CA',
};